// extracted by mini-css-extract-plugin
module.exports = {"grid":"e_Fj","leaderboard":"e_Gj"};